import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { InventoryPurchaseLineServicesComponent } from "../inventory-purchase-line-services/inventory-purchase-line-services.component";
import { InventoryPurchaseFinishedGoodsListingComponent } from "../inventory-purchase-finished-goods-listing/inventory-purchase-finished-goods-listing.component";
import { v4 as uuidv4 } from "uuid";
import { InventoryPurchaseService } from "../../../core/services/inventory-purchase.service";
import { ConfirmationService } from "primeng/api";
import { ActivatedRoute, Router } from "@angular/router";
import { Address } from "../../../core/models/shared/address";
import { ShippingMethod } from "../../../core/models/shared/shippingMethod";
import { LoaderService } from "../../../core/services/loader.service";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import { SamplepoSummaryService } from "../../../core/services/samplepo-summary.service";
import { UserRole } from "../../../shared/enums/userRoles.enum";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { UserManagementService } from "../../../core/services/user-management.service";
import { CommonModule, DatePipe } from "@angular/common";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { SelectModule } from "primeng/select";
import { FinishedGoodsTemplateComponent } from "../finished-goods-template/finished-goods-template.component";
import { InventoryPurchaseLineServicesFormComponent } from "../inventory-purchase-line-services-form/inventory-purchase-line-services-form.component";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ChildPoConfirmationComponent } from "../child-po-confirmation/child-po-confirmation.component";
import { ConfirmLineGroupRequestDto } from "../../../core/models/samplePO/details/confirmLineGroupRequestDto";
import { CopyPOLinesRequestDto } from "../../../core/models/samplePO/details/copyPOLinesRequestDto";
import { ItemsSecurity } from "../../../core/models/samplePO/details/itemsSecurity";
import { PurchaseOrderHeader } from "../../../core/models/samplePO/details/purchaseOrderHeader";
import { PurchaseOrderLine } from "../../../core/models/samplePO/details/purchaseOrderLine";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-inventory-purchase-lines",
  templateUrl: "./inventory-purchase-lines.component.html",
  styleUrls: ["./inventory-purchase-lines.component.scss"],
  providers: [ConfirmationService],
  imports: [
    CommonModule,
    ModalStackerComponent,
    ReactiveFormsModule,
    SelectModule,
    InventoryPurchaseFinishedGoodsListingComponent,
    InventoryPurchaseLineServicesComponent,
    FinishedGoodsTemplateComponent,
    InventoryPurchaseLineServicesFormComponent,
    ConfirmDialogModule,
    ChildPoConfirmationComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class InventoryPurchaseLinesComponent implements OnInit {
  linesGroup: string[] = [];
  selectedLineGroup = "";
  siteDropDown = ["CA"];
  wareHouseDropDown = ["DG"];
  locationDropDown = ["REDHAT", "BOOZALLEN"];
  filterLocationDropDown = ["REDHAT", "BOOZALLEN"];
  linesGroupForm!: FormGroup;

  purchaseOrderHeader: PurchaseOrderHeader = {} as PurchaseOrderHeader;
  purchaseOrderHeaderAddress: Address = {} as Address;

  serviceLines: PurchaseOrderLine[] = [];
  finishedGoodsList: PurchaseOrderLine[] = [];
  allLines: PurchaseOrderLine[] = [];
  selectedOrder = "";

  printPdfModal = false;
  openPrinfPdfFlag = false;
  purchaseOrderLine: string[] = [];

  userRole = 0;
  enumUserRole = UserRole;
  productSecurity = {} as ItemsSecurity;
  inventoryServiceLinesDisplayModal = false;
  createFinishedGoodsDisplayModal = false;

  shippingProductsList: ShippingMethod[] = [];
  invPurchaseCompleted = false;

  @Input() purchaseOrderNumber = "";
  @Input() fromStacker = false;
  @Output() closeEvent = new EventEmitter();

  @ViewChild("serviceLineComponent", { static: false })
  serviceLineComponent!: InventoryPurchaseLineServicesComponent;
  @ViewChild("finishedGoodsComponent", { static: false })
  finishedGoodsComponent!: InventoryPurchaseFinishedGoodsListingComponent;
  //currencyConversion: any;
  selectedServiceLine!: PurchaseOrderLine;
  constructor(
    private _fb: FormBuilder,
    private _samplepoListingService: SamplepoListingService,
    private route: ActivatedRoute,
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _samplePOSummaryService: SamplepoSummaryService,
    private _inventoryPurchaseSummaryService: InventoryPurchaseService,
    private _loginService: UserManagementService,
    private router: Router,
    public datepipe: DatePipe,
    private confirmationService: ConfirmationService
  ) {
    this.initializeForm();
    this.route.params.subscribe(params => {
      this.purchaseOrderNumber = params["purchaseOrderNumber"];
    });
  }

  ngOnInit() {
    this.getInventoryPurchaseHeader();
    this.getAllGroupedInventoryLines();
    this.getAllChildPo();
    this.getUserProfile();
    this.supportRoles();
    this.getAllShippingMethod();
  }

  initializeForm() {
    this.linesGroupForm = this._fb.group({
      lineGroup: [{ value: "", disabled: true }],
      site: [{ value: "", disabled: true }],
      warehouse: [{ value: "", disabled: true }],
      location: [{ value: "", disabled: true }], //location added
      owner: [{ value: "", disabled: true }],
      mockGPercentage: [{ value: "", disabled: true }],
      jobName: [{ value: "" }],
    });
  }

  selectItem(item: string): void {
    this.selectedLineGroup = item;
    const gp = this.finishedGoodsList.find(it => it.lineGroupD365 === item);
    this.linesGroupForm.patchValue({
      lineGroup: this.selectedLineGroup,
      mockGPercentage: gp?.mockGPPercentD365?.toFixed(2),
    });
  }

  resetSelectedServiceLine() {
    this.selectedServiceLine = {} as PurchaseOrderLine;
    this.selectedOrder = "";
  }

  getInventoryPurchaseHeader() {
    this._samplepoListingService
      .getInventoryPurchaseHeader(this.purchaseOrderNumber)
      .subscribe({
        next: res => {
          this.purchaseOrderHeader = res.data?.purchaseOrderHeader;
          this.purchaseOrderHeaderAddress =
            res.data?.address ?? ({} as Address);
          this.linesGroupForm.patchValue({
            lineGroup: this.selectedLineGroup,
            site: this.purchaseOrderHeader.siteD365,
            warehouse: this.purchaseOrderHeader.warehouseD365,
            owner: this.purchaseOrderHeader.ownerD365,
            location: this.purchaseOrderHeader.storeD365,
          });

          this.setJobName();
          this.setLocation();
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getAllShippingMethod() {
    this._samplepoListingService.getAllShippingMethod().subscribe({
      next: res => {
        const shippingData = res.data;
        this.shippingProductsList = shippingData.filter(
          x => x.jniUseOnSalesOrderD365 !== "No"
        );
        // if (this.shippingMethod) {
        //   this.onShippingMethodSelect(this.shippingMethod);
        // }
      },
    });
  }

  calculateNet(onSave?: boolean) {
    let sumOfLineAmount = 0;
    this.serviceLineComponent.filteredServiceLines
      .filter(x => !x.excludedD365)
      .forEach(x => {
        if (x.currencyCodeD365?.toLowerCase() == "usd") {
          sumOfLineAmount = sumOfLineAmount + (x.lineAmountD365 ?? 0);
        } else {
          sumOfLineAmount = x.amountInTransactionCurrency
            ? sumOfLineAmount + (x.amountInTransactionCurrency ?? 0)
            : sumOfLineAmount + (x.lineAmountD365 ?? 0);
        }
      });

    let totalQuantity = 0;
    this.finishedGoodsComponent.filteredFinishedGoodsList.forEach(
      x =>
        (totalQuantity = totalQuantity + (x.orderedPurchaseQuantityD365 ?? 0))
    );

    this.finishedGoodsComponent.filteredFinishedGoodsList.forEach(x => {
      this.finishedGoodsComponent.onNetConversion(
        (sumOfLineAmount / totalQuantity).toString(),
        x
      );
    });

    this.calculateGPPercentage();

    if (!onSave) {
      this.addAndUpdateLineGroup([
        ...this.finishedGoodsComponent.filteredFinishedGoodsList,
        ...this.serviceLineComponent.filteredServiceLines.map(item => {
          return {
            ...item,
            requestedDeliveryDateD365: this.changeDateFormat(
              item.requestedDeliveryDateD365
            ),
            requestedShippingDateD365: this.changeDateFormat(
              item.requestedShippingDateD365
            ),
          };
        }),
      ]);
      this._toastr.success("NET calculated successfully.", "Success");
    }
  }

  calculateGPPercentage() {
    let sumOfSellTotal = 0;
    let sumOfNetTotal = 0;
    this.finishedGoodsComponent.filteredFinishedGoodsList.forEach(item => {
      sumOfSellTotal += item.mockSellTotalD365 ?? 0;
      sumOfNetTotal += item.lineAmountD365 ?? 0;
    });
    if (sumOfSellTotal > 0) {
      const calculateGpPercentage =
        ((sumOfSellTotal - sumOfNetTotal) / sumOfSellTotal) * 100;

      this.finishedGoodsComponent.filteredFinishedGoodsList =
        this.finishedGoodsComponent.filteredFinishedGoodsList.map(item => {
          return {
            ...item,
            mockGPPercentD365: calculateGpPercentage,
          };
        });
      this.linesGroupForm.patchValue({
        mockGPercentage: calculateGpPercentage
          ? calculateGpPercentage.toFixed(2)
          : 0,
      });
    } else {
      this.linesGroupForm.patchValue({
        mockGPercentage: "0.00",
      });
    }
  }

  addAndUpdateLineGroup(purchaseOrderLines: PurchaseOrderLine[]) {
    this._loaderService.setLoaderState(true);
    this._samplepoListingService
      .addAndUpdateLineGroup(purchaseOrderLines)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() == "success") {
            this._toastr.success(
              res.message || "Net Updated Successfully",
              "Success"
            );
          } else {
            this._toastr.error(
              res.message || "Error While Updating Net",
              "Error"
            );
          }

          this.ngOnInit();
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  createNewLineGroup() {
    const currentMaxGroup = this.linesGroup[0];
    if (!currentMaxGroup) {
      this.linesGroup.push(`${this.purchaseOrderNumber}-1`);
    } else {
      const maxDigit = parseInt(currentMaxGroup[currentMaxGroup.length - 1]);
      this.linesGroup.push(`${this.purchaseOrderNumber}-${maxDigit + 1}`);
    }
    this.linesGroup.sort((a, b) => b.localeCompare(a));
    this.selectedLineGroup = this.linesGroup[0];
    this.linesGroupForm.patchValue({
      lineGroup: this.selectedLineGroup,
      location: this.purchaseOrderHeader?.storeD365 || "",
      jobName: this.purchaseOrderHeader?.jobNameD365 || "",
      mockGPercentage: 0,
    });

    this.addTemplate();
  }

  confirmLineGroup() {
    const checkItems = this.finishedGoodsComponent.checkLineItems();
    if (checkItems.isRestricted) {
      this._toastr.error(
        "Error",
        `Inactive item(s) ${checkItems.items[0].itemNumberD365}. Select an alternate item and try again.`
      );
      return;
    }

    const isQuantityZero =
      this.serviceLineComponent.filteredServiceLines.filter(
        item =>
          !item.orderedPurchaseQuantityD365 ||
          item.orderedPurchaseQuantityD365 <= 0
      );

    if (isQuantityZero.length > 0) {
      this._toastr.error("Error", "ZERO quantity not allowed for Services");
      return;
    }
    const otherLines = this.finishedGoodsList.filter(
      x => x.lineGroupD365 && x.lineGroupD365 != this.selectedLineGroup
    );
    const duplicateLineSet = this.checkDuplicateItem([
      ...this.finishedGoodsComponent.filteredFinishedGoodsList,
      ...otherLines,
    ]);

    if (duplicateLineSet.size > 0) {
      this._toastr.error(
        "Error",
        `Item Numbers: ${[...duplicateLineSet].join(", ")} are duplicate`
      );
      return;
    }

    const isHandsDate = this.checkInhandsDate(
      this.serviceLineComponent.filteredServiceLines
    );

    if (isHandsDate) {
      this._toastr.error("Error", `In-hands date can not be empty`);
      return;
    }

    let sumOfLineAmount = 0;
    this.serviceLineComponent.filteredServiceLines
      .filter(x => !x.excludedD365)
      .forEach(x => {
        if (x.currencyCodeD365?.toLowerCase() == "usd") {
          sumOfLineAmount = sumOfLineAmount + (x.lineAmountD365 ?? 0);
        } else {
          sumOfLineAmount = x.amountInTransactionCurrency
            ? sumOfLineAmount + (x.amountInTransactionCurrency ?? 0)
            : sumOfLineAmount + (x.lineAmountD365 ?? 0);
        }
      });

    let totalQuantity = 0;
    this.finishedGoodsComponent.filteredFinishedGoodsList
      .filter(x => !x.lineRecIdD365)
      .forEach(
        x =>
          (totalQuantity = totalQuantity + (x.orderedPurchaseQuantityD365 ?? 0))
      );

    this.finishedGoodsComponent.filteredFinishedGoodsList
      .filter(x => !x.lineRecIdD365)
      .forEach(x => {
        this.finishedGoodsComponent.onNetConversion(
          (sumOfLineAmount / totalQuantity).toString(),
          x
        );
      });

    // for (const line of this.finishedGoodsComponent.filteredFinishedGoodsList) {
    //   if (line.orderedPurchaseQuantityD365 == 0) {
    //     this._toastr.error('Error', 'Quantity Can Not be 0');
    //     return;
    //   }
    // }

    this.calculateGPPercentage();
    const request: ConfirmLineGroupRequestDto = {
      purchaseOrderNumber: this.purchaseOrderNumber,
      purchaseOrderLine: this.finishedGoodsComponent.filteredFinishedGoodsList,
      lineGroup: this.selectedLineGroup,
    };
    this._loaderService.setLoaderState(true);
    this._samplepoListingService.confirmLineGroup(request).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.status.toLowerCase() == "success") {
          this._toastr.success(res.message, "Success");
        } else {
          this._toastr.success(
            res.message || "Error from D365 when creating line group",
            "Error"
          );
        }
        this.ngOnInit();
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.success("Error when creating line group", "Error");
      },
    });
  }

  changeDateFormat(date: Date | string | null) {
    if (date && typeof date === "object") {
      date = this.datepipe.transform(date, "MM/dd/yyyy");
    }
    return date;
  }
  checkDuplicateItem(lines: PurchaseOrderLine[]): Set<string> {
    const itemMap = new Map<string, number>();
    const duplicateItemNumber = new Set<string>();
    for (const line of lines) {
      if (line.itemNumberD365) {
        if (
          itemMap.get(
            `${line.itemNumberD365}${line.styleD365}${line.sizeD365}${line.colorD365}${line.configD365}`
          )
        ) {
          duplicateItemNumber.add(line.itemNumberD365);
        } else {
          itemMap.set(
            `${line.itemNumberD365}${line.styleD365}${line.sizeD365}${line.colorD365}${line.configD365}`,
            (itemMap.get(
              `${line.itemNumberD365}${line.styleD365}${line.sizeD365}${line.colorD365}${line.configD365}`
            ) ?? 0) + 1
          );
        }
      }
    }

    return duplicateItemNumber;
  }

  checkInhandsDate(lines: PurchaseOrderLine[]): boolean {
    for (const line of lines) {
      if (!line.requestedDeliveryDateD365) {
        return true;
      }
    }

    return false;
  }

  supportRoles() {
    this._samplepoListingService
      .supportRoles()
      .pipe()
      .subscribe({
        next: res => {
          this.productSecurity = res.data;
          this.updateLocations();
        },
      });
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe(res => {
        this.userRole = res.data.userRoleId;
        this.updateLocations();
      });
  }

  updateLocations() {
    if (this.userRole !== this.enumUserRole.Admin) {
      this.filterLocationDropDown = [];
      if (this.productSecurity && Object.keys(this.productSecurity).length) {
        if (this.productSecurity.redHat) {
          this.filterLocationDropDown = this.locationDropDown.filter(
            x => x == "REDHAT"
          );
        }

        if (this.productSecurity.boozAllen) {
          const boozProducts = this.locationDropDown.filter(
            x => x == "BOOZALLEN"
          );
          this.filterLocationDropDown.push(...boozProducts);
        }
      }
    }
  }

  selectedLineGroupChangeEvent(lineGroup: string) {
    const serviceLines = this.serviceLines.filter(
      x => x.lineGroupD365 == lineGroup
    );
    const finishedLines = this.finishedGoodsList.filter(
      x => x.lineGroupD365 == lineGroup
    );

    const lines: PurchaseOrderLine[] = [...serviceLines, ...finishedLines];

    if (!lines?.length) {
      return;
    }

    this._loaderService.setLoaderState(true);
    if (lines.length > 0) {
      lines.forEach((value: PurchaseOrderLine) => {
        value.rsmFirmD365 = value.rsmFirmD365?.toString() ?? "false";
      });
    }
    this._samplepoListingService.addLineGroup(lines).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.status.toLowerCase() === "success") {
          this._toastr.success(res.message, "Success");
          this.ngOnInit();
          return;
        }

        this._toastr.error(res.message, "Error");
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  printLine() {
    this._loaderService.setLoaderState(true);
    this._samplePOSummaryService
      .confirmPurchaseOrder(this.purchaseOrderHeader?.purchaseOrderNumberD365)
      .subscribe({
        next: res => {
          if (!res.data) {
            if (res.message) {
              this._toastr.error("Error", res.message);
            } else {
              this._toastr.error("Error", "Failed to Add in D365");
            }
            this._loaderService.setLoaderState(false);
            return;
          }
          if (res.message) {
            this._toastr.success("Success", res.message);
          } else {
            this._toastr.success("Success", "Added in D365");
          }
          this._loaderService.setLoaderState(false);
          this.ngOnInit();
        },
        error: res => {
          this._toastr.error("Error", res.message || "Failed To Add In D365");
          this._loaderService.setLoaderState(false);
        },
      });
  }

  confirmInventoryPurchase() {
    this._loaderService.setLoaderState(true);
    this._samplePOSummaryService
      .confirmInventoryPurchase(
        this.purchaseOrderHeader?.purchaseOrderNumberD365,
        this.invPurchaseCompleted
      )
      .subscribe({
        next: res => {
          if (!res.data) {
            if (res.message) {
              this._toastr.error("Error", res.message);
            } else {
              this._toastr.error("Error", "Failed to Add in D365");
            }
            this._loaderService.setLoaderState(false);
            return;
          }
          if (res.message) {
            this._toastr.success("Success", res.message);
          } else {
            this._toastr.success("Success", "Added in D365");
          }
          this._loaderService.setLoaderState(false);
          this.ngOnInit();
        },
        error: res => {
          this._toastr.error("Error", res.message || "Failed To Add In D365");
          this._loaderService.setLoaderState(false);
        },
      });
  }

  setJobName() {
    let jobName = this.serviceLineComponent?.filteredServiceLines?.find(
      x => x.jobNameD365
    )?.jobNameD365;
    if (!jobName) {
      jobName = this.finishedGoodsComponent?.filteredFinishedGoodsList?.find(
        x => x.jobNameD365
      )?.jobNameD365;
    }

    if (!jobName && this.purchaseOrderHeader) {
      this.linesGroupForm.patchValue({
        jobName: this.purchaseOrderHeader.jobNameD365,
      });
    } else {
      this.linesGroupForm.patchValue({
        jobName: jobName,
      });
    }
  }

  setLocation() {
    let location = this.serviceLineComponent?.filteredServiceLines?.find(
      x => x.wMSLocationD365
    )?.wMSLocationD365;
    if (!location) {
      location = this.finishedGoodsComponent?.filteredFinishedGoodsList?.find(
        x => x.wMSLocationD365
      )?.wMSLocationD365;
    }

    if (!location && this.purchaseOrderHeader) {
      this.linesGroupForm.patchValue({
        location: this.purchaseOrderHeader.storeD365,
      });
    } else {
      this.linesGroupForm.patchValue({
        location: location,
      });
    }
  }

  getAllGroupedInventoryLines() {
    this._loaderService.setLoaderState(true);
    this._samplepoListingService
      .getAllGroupedInventoryLines(this.purchaseOrderNumber)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          res.data.forEach(x => (x.portalKeyD365 = uuidv4()));

          this.allLines = res.data;

          this.serviceLines = res.data.filter(x => !x.parentD365);
          this.finishedGoodsList = res.data.filter(x => x.parentD365);

          // Retain the PO line groups after adding/committing a line.
          if (!this.selectedLineGroup) {
            this.linesGroup = [
              ...new Set(res.data.map(x => x.lineGroupD365)),
            ].sort((a, b) => b.localeCompare(a));

            this.selectedLineGroup = this.linesGroup[0] || "";
          }

          //const gp = res.data.find(
          //  item => item.lineGroupD365 === this.selectedLineGroup
          //);
          //this.linesGroupForm.patchValue({
          //  lineGroup: this.selectedLineGroup,
          //  mockGPercentage: gp?.mockGPPercentD365?.toFixed(2),
          //});

          let netTotal = 0;
          let sellTotal = 0;
          res.data.forEach(item => {
            if (
              item.lineGroupD365 === this.selectedLineGroup &&
              item.parentD365 === true
            ) {
              netTotal += item.lineAmountD365 ?? 0;
              sellTotal += item.mockSellTotalD365 ?? 0;
            }
          });

          let gpPercentage = 0;
          if (sellTotal !== 0) {
            gpPercentage = ((sellTotal - netTotal) / sellTotal) * 100;
          }

          this.linesGroupForm.patchValue({
            lineGroup: this.selectedLineGroup,
            mockGPercentage: gpPercentage?.toFixed(2) || 0,
          });

          this.setJobName();
          this.setLocation();
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  onDeleteLineGroup() {
    if (this.selectedLineGroup) {
      const lineGroupExist = this.allLines.find(
        x => x.id && x.lineGroupD365 == this.selectedLineGroup
      );

      if (lineGroupExist) {
        this._loaderService.setLoaderState(true);
        this._samplePOSummaryService
          .deleteLineGroup(this.selectedLineGroup)
          .subscribe({
            next: res => {
              this._loaderService.setLoaderState(false);
              if (res.status.toLowerCase() != "success") {
                this._toastr.error(
                  "Error",
                  res.message || "Failed To Update Line"
                );
              } else {
                this._toastr.success(
                  "Success",
                  res.message || "Line Group Deleted Successfully"
                );
              }

              this.ngOnInit();
            },
            error: res => {
              this._loaderService.setLoaderState(false);
              this._toastr.error(
                "Error",
                res.message || "Error Deleting Line Group"
              );
            },
          });
      } else {
        const index = this.linesGroup.indexOf(this.selectedLineGroup);

        if (index > -1) {
          this.linesGroup.splice(index, 1);

          this.selectedLineGroup = this.linesGroup[0] || "";
          this.linesGroupForm.patchValue({
            lineGroup: this.selectedLineGroup,
          });
        }
      }
    } else {
      this._toastr.error("Error", "Select a line group first");
    }
  }

  onRowEditSave(purchaseOrderLine: PurchaseOrderLine) {
    if (purchaseOrderLine?.id) {
      const updateSamplePOLineDto = {
        purchaseOrderLine: purchaseOrderLine,
      };
      if (updateSamplePOLineDto?.purchaseOrderLine) {
        updateSamplePOLineDto.purchaseOrderLine.rsmFirmD365 =
          updateSamplePOLineDto.purchaseOrderLine.rsmFirmD365?.toString() ??
          "false";
      }
      this._loaderService.setLoaderState(true);
      this._samplePOSummaryService
        .updatePOLineGroup(updateSamplePOLineDto)
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() != "success") {
              this._toastr.error(
                "Error",
                res.message || "Failed To Update Line"
              );
              return;
            }

            if (res.data) {
              this._toastr.success(
                "Success",
                res.message || "Line Updated Successfully"
              );
              //this.inventoryServiceLinesDisplayModal = false;
            } else {
              this._loaderService.setLoaderState(false);
              this._toastr.error(
                "Error",
                res.message || "Error Updating Lines"
              );
            }

            this.ngOnInit();
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Error Updating Lines");
          },
        });
    } else {
      const lines: PurchaseOrderLine[] = [purchaseOrderLine];

      this._loaderService.setLoaderState(true);
      if (lines.length > 0) {
        lines.forEach((value: PurchaseOrderLine) => {
          value.rsmFirmD365 = value.rsmFirmD365?.toString() ?? "false";
        });
      }
      this._samplepoListingService.addLineGroup(lines).subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() === "success") {
            this._toastr.success(res.message, "Success");
            this.ngOnInit();
            return;
          }

          this._toastr.error(res.message, "Error");
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
    }
  }

  copyPOLine(selectPoLines: PurchaseOrderLine[]) {
    this._loaderService.setLoaderState(true);
    const addUpdateSamplePOLineDto: CopyPOLinesRequestDto = {
      purchaseOrderLine: selectPoLines,
      purchaseOrderNumber: this.purchaseOrderNumber,
    };
    this._samplePOSummaryService
      .copyPOLines(addUpdateSamplePOLineDto)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.ngOnInit();
            this._toastr.success("Success", "Line(s) Copied Successfully");
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Error Copying Lines");
        },
      });
  }

  closePrinfPdfModal() {
    this.printPdfModal = false;
  }

  openPrinfPdfModal() {
    if (this.purchaseOrderLine.length === 1) {
      this.onPreview(this.purchaseOrderLine[0]);
    } else {
      this.printPdfModal = true;
    }
  }

  getAllChildPo() {
    this._inventoryPurchaseSummaryService
      .getAllChildPo(this.purchaseOrderNumber)
      .subscribe({
        next: res => {
          this.purchaseOrderLine = res.data;
          if (this.purchaseOrderLine.length > 0) {
            this.openPrinfPdfFlag = true;
          } else {
            this.openPrinfPdfFlag = false;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  onPreview(purchaseNumber: string) {
    this._loaderService.setLoaderState(true);
    this._samplePOSummaryService
      .getPurchaseOrderConfirmationJournal(purchaseNumber)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (!res.data) {
            this._toastr.error("Error", res.message);
            return;
          }
          const blob = this.b64toBlob(res.data, "application/pdf");
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Failed To Load PDF");
        },
      });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  deleteInventoryLine(selectPoLines: PurchaseOrderLine[]) {
    const idList = selectPoLines.filter(x => x.id).map(x => x.id);
    if (idList.length > 0) {
      this._loaderService.setLoaderState(true);
      this._samplePOSummaryService.deleteInventoryLines(idList).subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() == "success") {
            this._toastr.success(
              "Success",
              res.message || "Line(s) Deleted Successfully"
            );
          } else {
            this._toastr.success("Error", res.message || "Error Deleing Line");
          }

          this.ngOnInit();
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Error Deleting Lines");
        },
      });
    }
  }

  onSave() {
    this.calculateNet(true);
    const serviceLines = this.serviceLineComponent.filteredServiceLines.map(
      item => {
        return {
          ...item,
          requestedDeliveryDateD365: this.changeDateFormat(
            item.requestedDeliveryDateD365
          ),
          requestedShippingDateD365: this.changeDateFormat(
            item.requestedShippingDateD365
          ),
        };
      }
    );
    const finishedLines = this.finishedGoodsComponent.filteredFinishedGoodsList;

    const lines: PurchaseOrderLine[] = [...serviceLines, ...finishedLines];

    if (!lines?.length) {
      this._toastr.error(
        "No new Lines Found in the line group to add",
        "Error"
      );
      return;
    }

    if (lines.length > 0) {
      lines.forEach((value: PurchaseOrderLine) => {
        value.rsmFirmD365 = value.rsmFirmD365?.toString() ?? "false";
      });
    }

    this._loaderService.setLoaderState(true);
    this._samplepoListingService.addLineGroup(lines).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.status.toLowerCase() === "success") {
          this._toastr.success("PO Line Group saved successfully.", "Success");
          this.ngOnInit();
          return;
        }

        this._toastr.error(res.message, "Error");
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  onCancel() {
    if (this.fromStacker) {
      this.closeEvent.emit();
    } else {
      this.router.navigate([
        `inventory-purchase/inventory-purchase-summary/${this.purchaseOrderNumber}`,
      ]);
    }
  }

  updateLines() {
    this.serviceLineComponent.filteredServiceLines.forEach(x => {
      x.jobNameD365 = this.linesGroupForm.get("jobName")?.value;
      x.wMSLocationD365 = this.linesGroupForm.get("location")?.value;
    });

    this.finishedGoodsComponent.filteredFinishedGoodsList.forEach(x => {
      x.jobNameD365 = this.linesGroupForm.get("jobName")?.value;
      x.wMSLocationD365 = this.linesGroupForm.get("location")?.value;
    });

    const serviceLines = this.serviceLineComponent.filteredServiceLines.map(
      item => {
        return {
          ...item,
          requestedDeliveryDateD365: this.changeDateFormat(
            item.requestedDeliveryDateD365
          ),
          requestedShippingDateD365: this.changeDateFormat(
            item.requestedShippingDateD365
          ),
        };
      }
    );
    const finishedGoods = this.finishedGoodsComponent.filteredFinishedGoodsList;
    const lines = [...serviceLines, ...finishedGoods];
    if (lines.length > 0) {
      this.addAndUpdateLineGroup(lines);
    }
  }

  closeModalFromInventoryServiceLines() {
    this.inventoryServiceLinesDisplayModal = false;
    this.ngOnInit();
  }

  toggleModal(flag: boolean) {
    this.inventoryServiceLinesDisplayModal = flag;
  }

  addNewServiceLine() {
    this.selectedServiceLine = {} as PurchaseOrderLine;
    this.selectedOrder = "";
    this.inventoryServiceLinesDisplayModal = true;
  }

  closeModalFromCreateFinishedGoods() {
    this.createFinishedGoodsDisplayModal = false;
    this.checkEmptyLineGroup();
    // this.ngOnInit();
  }

  checkEmptyLineGroup() {
    const serviceLines = this.serviceLineComponent.filteredServiceLines.map(
      item => {
        return {
          ...item,
          requestedDeliveryDateD365: this.changeDateFormat(
            item.requestedDeliveryDateD365
          ),
          requestedShippingDateD365: this.changeDateFormat(
            item.requestedShippingDateD365
          ),
        };
      }
    );
    const finishedLines = this.finishedGoodsComponent.filteredFinishedGoodsList;

    if (!(serviceLines.length || finishedLines.length)) {
      this.selectedLineGroup = "";
      this.linesGroup = [];
    }
  }

  addTemplate() {
    this.createFinishedGoodsDisplayModal = true;
  }

  // updateInventoryHeader() {
  //   this.purchaseOrderHeader.jobNameD365 =
  //     this.linesGroupForm.get('jobName')?.value;
  //   const payload = {
  //     purchaseOrderHeaderAddressDto: {
  //       address: this.purchaseOrderHeaderAddress,
  //       purchaseOrderHeader: this.purchaseOrderHeader
  //     }
  //   };

  //   this._inventoryPurchaseSummaryService.updateInventoryPO(payload).subscribe({
  //     next: (res) => {
  //       if (res.status.toLowerCase() != 'success') {
  //         this._toastr.success('Error', res.message);
  //         return;
  //       }
  //       this._toastr.success('Success', 'Job Name Updated');
  //     },
  //     error: (res) => {
  //       this._loaderService.setLoaderState(false);
  //       this._toastr.error('Error', res.message || 'Failed To Update Job Name');
  //     }
  //   });
  // }

  setServiceItemLine(serviceItem: PurchaseOrderLine) {
    this.selectedServiceLine = serviceItem;
    this.selectedOrder = serviceItem.id.toString();
    this.inventoryServiceLinesDisplayModal = true;
  }

  completeComfirmationForInvPO() {
    this.confirmationService.confirm({
      message: "Do you want to send inventory receipt to the warehouse?",
      acceptLabel: "Yes",
      rejectLabel: "No",
    });
  }

  dialogBoxButtonEvent(event: number) {
    switch (event) {
      case 1:
        this.invPurchaseCompleted = true;
        this.confirmInventoryPurchase();
        break;

      case 2:
        this.invPurchaseCompleted = false;
        this.confirmInventoryPurchase();
        break;

      default:
        break;
    }

    this.confirmationService.close();
  }
}
